import * as React from "react";
const SvgFiRrLeafHeart = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-leaf-heart_svg__a)">
      <path
        fill="#062147"
        d="M22.603.305C21.896-.104 21.078-.1 20.42.31c-2.582 1.602-5.086 1.766-7.508 1.925-2.743.18-5.58.366-7.997 2.783a9.86 9.86 0 0 0-2.912 7.241 9.84 9.84 0 0 0 2.248 6.076L.293 22.291a.999.999 0 1 0 1.414 1.414l3.956-3.956a9.5 9.5 0 0 0 6.065 2.15q.456 0 .918-.042c2.997-.267 5.772-1.812 7.616-4.24C22.527 14.63 23.784 9.644 24 2.798c.03-.993-.53-1.996-1.397-2.495zM18.67 16.408c-1.503 1.98-3.763 3.241-6.2 3.458-2.217.197-4.309-.5-5.896-1.96a7.9 7.9 0 0 1-2.57-5.689 7.88 7.88 0 0 1 2.325-5.786c1.885-1.885 4.123-2.032 6.714-2.2 2.543-.168 5.425-.357 8.432-2.223a.05.05 0 0 1 .03-.009c.02 0 .05.008.1.038.198.114.406.415.396.7-.198 6.332-1.35 11.06-3.33 13.67zm-4.225-8.41c-.759 0-1.433.255-1.944.688a2.98 2.98 0 0 0-1.944-.688c-1.623 0-2.944 1.391-2.944 3.1 0 2.555 3.405 5.312 3.551 5.43.394.314.866.472 1.338.472s.944-.158 1.338-.473c.145-.116 3.552-2.873 3.552-5.429 0-1.709-1.32-3.1-2.945-3.1zm-1.856 6.968a.14.14 0 0 1-.176 0c-1.353-1.084-2.8-2.896-2.8-3.868 0-.606.423-1.1.943-1.1.436 0 .944.238.944.91a1 1 0 1 0 2 0c0-.672.51-.91.944-.91.521 0 .945.494.945 1.1 0 .972-1.448 2.785-2.802 3.868z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-leaf-heart_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrLeafHeart;
